import { tv } from 'tailwind-variants'

export const textCardVariants = tv({
  slots: {
    container: 'flex flex-col'
  }
})
